import dragonCore from "../images/wand/DragonHeartstringCore.png";
import phoenixCore from "../images/wand/PhoenixFeatherCore.png";
import unicornCore from "../images/wand/UnicornHairCore.png";
import dragonHand from "../images/wand/hand/DragonHeartstringCore_hand.png";
import phoenixHand from "../images/wand/hand/PhoenixFeatherCore_hand.png";
import unicornHand from "../images/wand/hand/UnicornHairCore_hand.png";

export const WANDS = [
  {
    id: "phoenix_feather",
    name: "Phoenix feather",
    description:
      "Rare and powerful magic with unpredictable potential.Capable of the most extraordinary and unexpected spells.",
    image: phoenixCore,
    handImage: phoenixHand,
  },
  {
    id: "dragon_heartstring",
    name: "Dragon heartstring",
    description:
      "Raw, intense magic with immense strength behind every spell.Delivers powerful results, but demands control from its wielder.",
    image: dragonCore,
    handImage: dragonHand,
  },
  {
    id: "unicorn_hair",
    name: "Unicorn hair",
    description:
      "Steady, loyal magic that rarely fails its wielder.Best suited for consistent and controlled spellcasting.",
    image: unicornCore,
    handImage: unicornHand,
  },
];
